import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { safeFileName } from "./poshanConstants";

export function printReport() {
  setTimeout(() => window.print(), 50);
}

export async function downloadPdf(reportRef, schoolInfo, activeReport) {
  if (!reportRef?.current) return;
  const pages = Array.from(reportRef.current.querySelectorAll(".print-page"));
  const margin = 8;
  let pdf = null;

  for (let index = 0; index < pages.length; index += 1) {
    const page = pages[index];
    // Landscape pages (Reports Hub day-wise ladoo tables, etc.) carry the
    // `.landscape` modifier — switch jsPDF orientation per-page so each
    // page in the same PDF can be in its natural aspect.
    const isLandscape = page.classList.contains("landscape");
    const orient = isLandscape ? "l" : "p";
    const pageWidth = isLandscape ? 297 : 210;
    const pageHeight = isLandscape ? 210 : 297;
    const maxWidth = pageWidth - margin * 2;
    const maxHeight = pageHeight - margin * 2;

    // eslint-disable-next-line no-await-in-loop
    const canvas = await html2canvas(page, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      windowWidth: page.scrollWidth,
    });
    const image = canvas.toDataURL("image/png");
    let imageWidth = maxWidth;
    let imageHeight = (canvas.height * imageWidth) / canvas.width;
    if (imageHeight > maxHeight) {
      imageHeight = maxHeight;
      imageWidth = (canvas.width * imageHeight) / canvas.height;
    }
    if (!pdf) {
      pdf = new jsPDF(orient, "mm", "a4");
    } else {
      pdf.addPage("a4", orient);
    }
    const x = margin + (maxWidth - imageWidth) / 2;
    const y = margin + (maxHeight - imageHeight) / 2;
    pdf.addImage(image, "PNG", x, y, imageWidth, imageHeight);
  }
  if (pdf) pdf.save(`${safeFileName(schoolInfo.schoolName)}_${activeReport}_${schoolInfo.financialYear}.pdf`);
}

function downloadBlob(content, fileName, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function rowsToHtml(rows) {
  return rows
    .map(
      (row) =>
        `<tr>${row
          .map(
            (cell) =>
              `<td style="border:1px solid #111;padding:6px;font-family:Calibri,Arial,sans-serif;">${
                cell === null || cell === undefined ? "" : String(cell)
              }</td>`,
          )
          .join("")}</tr>`,
    )
    .join("");
}

function buildExportHtml({ schoolInfo, quarterLabel, totals, ingredientWiseReport, annexureEntries }) {
  const summaryRows = [
    ["School", schoolInfo.schoolName],
    ["UDISE", schoolInfo.udiseCode],
    ["Quarter", quarterLabel],
    ["Financial Year", schoolInfo.financialYear],
    ["Total Grant Received", totals.totalGrantReceived],
    ["Total Cooking Cost", totals.totalCookingCost],
    ["Total Ingredient Expenditure", totals.totalIngredientExpenditure],
    ["Total Cook Payment", totals.totalCookPayment],
    ["Total Expenditure", totals.totalExpenditure],
    ["UC Utilized Amount", totals.ucUtilizedAmount],
    ["Remaining Balance", totals.remainingBalance],
    ["Total Rice Consumption", totals.totalRiceConsumption],
    ["Total Meals Served", totals.totalMealsServed],
  ];
  const ingredientRows = [
    ["Ingredient", "Quantity", "Unit", "Amount"],
    ...ingredientWiseReport.map((item) => [item.name, item.quantity, item.unit, item.amount]),
  ];
  const annexureRows = [
    ["Voucher No", "Date", "Details of Expenditure", "Amount", "Remarks"],
    ...annexureEntries.map((e) => [e.voucher, e.date, e.details, e.amount, e.remarks]),
  ];
  return `
    <html><head><meta charset="utf-8" /><title>PM POSHAN Quarterly UC Export</title></head>
    <body style="font-family:Calibri,Arial,sans-serif;">
      <h2>PM POSHAN Quarterly UC Export</h2>
      <h3>Quarterly Summary</h3><table style="border-collapse:collapse;">${rowsToHtml(summaryRows)}</table>
      <h3>Ingredient-wise Report</h3><table style="border-collapse:collapse;">${rowsToHtml(ingredientRows)}</table>
      <h3>Annexure Expenditure Statement</h3><table style="border-collapse:collapse;">${rowsToHtml(annexureRows)}</table>
    </body></html>`;
}

export function exportExcel(args) {
  const html = buildExportHtml(args);
  downloadBlob(
    html,
    `${safeFileName(args.schoolInfo.schoolName)}_PM_POSHAN_${args.schoolInfo.financialYear}.xls`,
    "application/vnd.ms-excel;charset=utf-8",
  );
}

export function exportWord(args) {
  const html = buildExportHtml(args);
  // .doc opens in Word from HTML. Adding the standard MS Word XML namespace helps Word recognise it.
  const wrapped = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">${html.replace(/^<html>/, "")}`;
  downloadBlob(
    wrapped,
    `${safeFileName(args.schoolInfo.schoolName)}_PM_POSHAN_${args.schoolInfo.financialYear}.doc`,
    "application/msword;charset=utf-8",
  );
}
